import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderStyleOneComponent } from '../../common/header-style-one/header-style-one.component';
import { BlogComponent } from '../../common/blog/blog.component';
// import { FeedbackStyleOneComponent } from '../../common/feedback-style-one/feedback-style-one.component';
// import { BecomeInstructorPartnerComponent } from '../../common/become-instructor-partner/become-instructor-partner.component';
// import { InstructorsStyleOneComponent } from '../../common/instructors-style-one/instructors-style-one.component';
// import { PartnerStyleOneComponent } from '../../common/partner-style-one/partner-style-one.component';
import { HomeoneCoursesComponent } from './homeone-courses/homeone-courses.component';
// import { FunfactsComponent } from '../../common/funfacts/funfacts.component';
// import { CategoriesStyleOneComponent } from '../../common/categories-style-one/categories-style-one.component';
import { HomeoneAboutComponent } from './homeone-about/homeone-about.component';
import { HomeoneMainBannerComponent } from './homeone-main-banner/homeone-main-banner.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AboutPageOneComponent } from '../about-page-one/about-page-one.component';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Registrationform } from './registrationform/registrationform';
import { NgSelectModule } from '@ng-select/ng-select';
import { Apiservice } from 'src/app/services/apiservice';
import Swal from 'sweetalert2';
import { Notifications } from './notifications/notifications';
@Component({
  selector: 'app-home-page-one',
  standalone: true,
  imports: [HeaderStyleOneComponent, RouterLink, MatTableModule, MatPaginatorModule, MatFormFieldModule, MatInputModule, MatSortModule, CommonModule, FormsModule, Registrationform, NgSelectModule,Notifications],
  templateUrl: './home-page-one.component.html',
  styleUrls: ['./home-page-one.component.scss']
})
export class HomePageOneComponent implements OnInit {
  headerclass = {
    // 'fontSize.px': 17,
    'fontWeight': 'bold',
    'background': '#BA4D13',
    'color': '#fff',
    'text-align': 'center',
    // 'padding': '8px',
  };
  filteredData: any[] = [];   // Filtered data based on search
  searchTerm: string = '';    // Search term
  sortColumn: string = '';   // Column to sort by
  sortDirection: 'asc' | 'desc' = 'asc';  // Sort direction
  @ViewChild(MatPaginator) paginator: MatPaginator;      // Mat Table Pagination selector
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('firstTableSort') public firstTableSort: MatSort;                     // Mat Table Sorting selector
  // 'vacancies',
  // 'age_limit', 'salary',
  displayedColumns: string[] = ['i', 'company_name', 'position', 'qualification', 'work_location', 'action'];
  dataSource: MatTableDataSource<any>;
  results_notifications_list: any = [];
  serch: any;
  jobsScrollData: any = [
    {
      "message": "MEPMA-NIPUNA JOB MELA 2025"
    }]

  districtData: any = [];
  showloader: any;
  melanotifcations: any = []
  constructor(private router: Router, private api: Apiservice,) { }

  ngOnInit(): void {
    this.getMelaNotifications();
    // this.getJobslist();
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getMelaNotifications() {
    this.showloader = true;
    this.api.getMelaNotifications().subscribe((res: any) => {
      if (res.status === 200) {
        this.melanotifcations = res.data;
        console.log(this.melanotifcations);
        this.showloader = false;
      }
    },
      (err) => {
        this.showloader = false;
        console.error('API error:', err);
      });
  }


  // getJobslist() {
  //   // console.log(this.jobsArray);
  //   this.showloader = true;
  //   this.api.getJobslist().subscribe((res: any) => {
  //     if (res.status === 200) {
  //       console.log(res.data);
  //       res.data.map(((respo, index) => {
  //         respo.i = index + 1;
  //       }))

  //       // this.arrayData = res.data;
  //       this.showloader = false;
  //       this.dataSource = new MatTableDataSource(res.data);
  //       console.log(this.dataSource);
  //       setTimeout(() => {
  //         this.dataSource.paginator = this.paginator;
  //         this.dataSource.sort = this.sort;
  //       }, 500);
  //     }
  //   },
  //     (err) => {
  //       this.showloader = false;
  //       console.error('API error:', err);
  //     }
  //   );
  // };

  navigteApplyForm(row) {
    // console.log(row);

    // Swal.fire({
    //   icon: 'info',
    //   title: 'Coming Soon',
    //   text: 'This feature will be available soon. Stay tuned!',
    //   confirmButtonText: 'OK'
    // });
    let access_token = localStorage.getItem('access_token');
    if (access_token) {
      this.showloader = true;
      this.api.getUserprofileData().subscribe((res: any) => {
        // console.log(res);
        this.showloader = false;
        if (res.status == 200) {
          let user = res.data[0];
          if (user.registration_status != 0) {
            console.log(row);
            this.router.navigate(['/applycompanies'], {
              queryParams: {
                reqId: row.mela_reqId ?? row.reqId
              }
            });
          } else {
            Swal.fire({
              title: 'Incomplete Registration',
              text: 'You must complete your registration before viewing your profile. Do you want to complete it now?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, complete now',
              cancelButtonText: 'No, later',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33'
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigateByUrl('/registration');
              } else {
                console.log('User chose not to register now.');
              }
            });
          }

        }
      }, err => {
        this.showloader = false;
      })
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Login Required',
        text: 'Please login to continue.',
        confirmButtonText: 'OK'
      });
    }

  }

    gotoviewDetails(row) {
    console.log(row);

    this.router.navigate(['/companydetails'], {
      queryParams: {
        reqId: row.reqId
      }
    })

  }
}
